import { Button } from '@bpinternal/ui-kit-next'
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { Plus } from 'lucide-react'
import { ComponentProps } from 'react'
import { Boundary, Page } from '~/components'
import { DeskRedirect } from '~/features/billing/components'
import { isLegacyBilling } from '~/features/billing/utils/billingVersion'
import { useCurrentRouteId } from '~/hooks'
import { NavbarActionsProvider, useNavbarActions } from '~/providers/NavbarACtionsContext'
import { useSuspenseQuery } from '~/services'

function NavbarActionsConsumer() {
  const { navbarActions } = useNavbarActions()
  return <>{navbarActions}</>
}

export const Route = createFileRoute('/workspaces/$workspaceId/usage')({
  component: Component,
})

function Component() {
  const { workspaceId } = Route.useParams()
  const { data: workspace } = useSuspenseQuery('workspaces_/$workspaceId_', { workspaceId })
  const currentRouteId = useCurrentRouteId() ?? ''

  if (!isLegacyBilling(workspace)) {
    return <DeskRedirect title="Manage usage in Desk" />
  }

  const items: ComponentProps<typeof Page>['navbarItems'] = [
    {
      children: 'Workspace',
      to: '/workspaces/$workspaceId/usage/monthly-summary',
    },
    {
      children: 'Bot',
      to: '/workspaces/$workspaceId/usage/ai-spend',
    },
  ]

  const itemsWithActiveState = items.map((i) => ({
    ...i,
    active: currentRouteId.includes(i?.to ?? 'not-a-path'),
  }))

  return (
    <NavbarActionsProvider>
      <Page
        title="Usage"
        actions={
          <Link to={'/workspaces/$workspaceId/billing'} params={{ workspaceId }}>
            <Button>
              <Plus />
              Increase Limits
            </Button>
          </Link>
        }
        navbarItems={itemsWithActiveState}
        navbarActions={<NavbarActionsConsumer />}
      >
        <Boundary>
          {/* TODO: Add Skeleton loading screen */}
          <Outlet />
        </Boundary>
      </Page>
    </NavbarActionsProvider>
  )
}
